
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'src/store';
import BoardLookup from 'components/common/BoardLookup.vue';

const ToolBar = defineComponent({
  components: {
    BoardLookup,
  },
  props: {},
  setup() {
    const $store = useStore();
    const $route = useRoute();

    const toggleSidebar = () => $store.dispatch('app/toggleLeftDrawerOpen');

    // todo: refactor computed to mapGetters
    return {
      route: $route,
      toggleSidebar,
      loading: computed(() => $store.getters['loading/something']),
      isConnected: computed(() => $store.state.socket.isConnected),
      pageTitle: computed(() =>
        $store.state.app.pageTitle
          ? $store.state.app.pageTitle
          : $route.meta.title
      ),
    };
  },
});

export default ToolBar;
